import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import type { RouterClient } from "@orpc/server";

import type { API } from "@/api/router";

const link = new RPCLink({
	url: new URL("/rpc", window.location.origin).href,
});

export const api: RouterClient<API> = createORPCClient(link);

export type TransactionList = Awaited<ReturnType<typeof api.transactions.list>>;
export type DaePaymentList = Awaited<ReturnType<typeof api.daePayments.list>>;
export type ReceiptList = Awaited<ReturnType<typeof api.receipts.list>>;
export type TreasuryList = Awaited<ReturnType<typeof api.treasury.list>>;
export type InboxList = Awaited<ReturnType<typeof api.inbox.list>>;
export type PayableList = Awaited<ReturnType<typeof api.payables.list>>;
export type InboundInvoiceList = Awaited<ReturnType<typeof api.qiveArchive.inboundInvoices>>;
export type CteList = Awaited<ReturnType<typeof api.qiveArchive.ctes>>;
export type CifList = Awaited<ReturnType<typeof api.cif.list>>;
export type AccessList = Awaited<ReturnType<typeof api.access.list>>;
export type Transaction = TransactionList["transactions"][number];
export type Supplier = TransactionList["suppliers"][number];
export type SupplyCategory = TransactionList["supplyCategories"][number];
